import { Linked } from "@type-r/models";
import { Button, PopupDialog, PrimaryButton } from "lqx-react/lib";
import React from "react";

export const PopupActionDialog = ({ $context }:
    {
        $context: Linked<{
            onApply: any,
            onCancel: any,
            actionType: String,
            actionText: String,
            isPopupOpen: boolean
        }>
    }) => {
    return (
        $context.value.isPopupOpen ?
            <PopupDialog
                title={$context.value.actionType}
                actions={
                    <>
                        <Button onClick={$context.value.onCancel}>Cancel</Button>
                        <PrimaryButton onClick={$context.value.onApply}>{$context.value.actionType}</PrimaryButton>
                    </>
                }
                maxWidth='sm'
                hideTitle={false}
                onClose={$context.value.actionType}>
                {$context.value.actionText}
            </PopupDialog> : <></>
    )
}